import React from "react";
import { Decimal, LiquityStoreState } from "@liquity/lib-base";
import { useLiquitySelector } from "@liquity/lib-react";

import { useLiquity } from "../hooks/LiquityContext";
import { shortenAddress } from "../utils/shortenAddress";

import Account from "../assets/images/account.svg"
import { SLSD, SFRXETH } from "../lexicon"

const select = ({ slsdBalance, psyBalance, collateralStates }: LiquityStoreState) => {
  // const collateralState = collateralStates[collateralKey];
  // const { price, balance } = collateralState;

  return {
    // price,
    // balance,
    slsdBalance,
    psyBalance
  }
};

export const UserAccount: React.FC = () => {
  const { account } = useLiquity();
  const { slsdBalance } = useLiquitySelector(select);

  return (
    <div className="flex flex-row items-cener">
      {/* <div className="hidden md:flex flex-row border-component rounded-lg p-2">
        <img src={SLSD.iconUrl} alt={SLSD.term} className="w-5 h-5" />
        <span className="text-style-item ml-1.5">
          {SLSD.term}
        </span>
        <span className="text-style-sub ml-1">${slsdBalance.prettify()}</span>
      </div> */}
      {/* <div className="hidden md:flex flex-row border-component rounded-lg p-2 ml-2">
        <img src={SFRXETH.iconUrl} alt={SFRXETH.term} className="w-5 h-5" />
        <span className="text-style-item ml-1.5">
          {SFRXETH.term}
        </span>
        <span className="text-style-sub ml-1">${balance.mul(price).prettify()}</span>
      </div> */}

      <div className="flex flex-row border-component rounded-lg p-2 ml-4">
        <img src={Account} alt="account" className="w-6 h-6" />
        <span className="text-style-item ml-2">
          {shortenAddress(account)}
        </span>
      </div>

    </div>
  );
};
